'use client';

export { default } from '@mui/base/useAutocomplete';
export * from '@mui/base/useAutocomplete';